import { getData, postData, putData, deleteData } from "../apiClient";

// get users with pagination
export const getRoomFacilitiesDetails = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/room-facility-detail/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Room Facilities with pagination API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// get user data with id
export const getRoomFacilitiesDetailsWithId = async ( id ) => {
  try {
    const result = await getData(`/room-facility-detail/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get user data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const getFacilityTypes = async () => {
  try {
    const result = await getData(`/room-facility-detail/types/all`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get user data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
}

// create user ** // Updated Api Error Handle Method
export const createRoomFacilityDetail = async ({ data }) => {
  try {
    const result = await postData(`/room-facility-detail/`, data, { "Content-Type": "multipart/form-data" });
    return {
      data: {
        success: true,
        data: result,
      },    
    };
  } catch (error) {
    console.error("user add API error:", error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete user
export const deleteRoomFacilitiesDetails = async ({ id }) => {
  try {
    const result = await deleteData(`/room-facility-detail/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Delete user API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// update user data
export const updateRoomFacilitiesDetails = async ({ id, data }) => {
  try {
    const result = await putData(`/room-facility-detail/${id}`, data, { "Content-Type": "multipart/form-data" });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update user API error:", error);
    return {
      data: {
        success: false,       
        error: error.status === 400 ? error.data.errors : error.message,
        status: error.status,
      },
    };
  }
};
